var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("b-form-input", {
            attrs: {
              id: "table-search",
              placeholder: "Search Blacklists",
              type: "text"
            },
            model: {
              value: _vm.searchIpAddress,
              callback: function($$v) {
                _vm.searchIpAddress = $$v
              },
              expression: "searchIpAddress"
            }
          }),
          _vm._v(" "),
          _c("b-table", {
            directives: [{ name: "b-scrollspy", rawName: "v-b-scrollspy" }],
            attrs: {
              outlined: "",
              striped: "",
              hover: "",
              items: _vm.blacklists,
              "head-variant": "light",
              fields: _vm.tableFields,
              filter: _vm.searchIpAddress,
              "show-empty": "",
              "empty-text": "No blacklists found."
            },
            scopedSlots: _vm._u([
              {
                key: "cell(expiresAt)",
                fn: function(data) {
                  return [
                    _c(
                      "span",
                      { class: { "text-danger": _vm.isExpired(data.item) } },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatExpiresAt(data.item)) +
                            "\n        "
                        )
                      ]
                    )
                  ]
                }
              },
              {
                key: "cell(actions)",
                fn: function(data) {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-danger border-0",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.deleteBlacklist(data.item.ipAddress)
                          }
                        }
                      },
                      [_c("span", { staticClass: "fa fa-trash" })]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }